import { apiUrls } from 'src/utils/properties';
import api, { Method } from '../../utils/apiManager.utils';

const getStudentEnrollSubject = async () => {
  return new Promise((resolve, reject) => {
    api(
      Method.GET,
      null,
      apiUrls.SUBJECT + apiUrls.STUDENT + apiUrls.ENROLL_SUBJECT
    )
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const enrollSubject = async (data: Object) => {
  return new Promise((resolve, reject) => {
    api(
      Method.POST,
      null,
      apiUrls.SUBJECT + apiUrls.STUDENT + apiUrls.STORE_ENROLL_SUBJECT,
      '',
      data,
      ''
    )
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getEnrolledSubjectByStudent = async () => {
  return new Promise((resolve, reject) => {
    api(
      Method.GET,
      null,
      apiUrls.SUBJECT + apiUrls.STUDENT + apiUrls.ENROLLED_SUBJECTS,
      '',
      '',
      ''
    )
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getSubjectById = async (subjectId: string, studentId: string) => {
  return new Promise((resolve, reject) => {
    api(
      Method.GET,
      null,
      apiUrls.SUBJECT +
        `/user/student?subjectId=${subjectId}&studentId=${studentId}`
    )
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export {
  getStudentEnrollSubject,
  enrollSubject,
  getEnrolledSubjectByStudent,
  getSubjectById
};
